import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import axiosInstance from "../../../../store/axios.instance";
import { inverseCleValeur, valeurExiste } from "../../../../utils";
import { useSearchParams } from "react-router-dom";

const CtaItem = ({ texte, showTags }) => {
  const [newTag, setNewTag] = useState("");
  const { adaccountId } = useSelector(state => state.auth.user);
  const dispatch = useDispatch();

  const deleteCta = id => {
    if (window.confirm("Voulez-vous vraiment supprimer ce cta ?")) {
      axiosInstance
        .delete(`/${adaccountId}/call_to_action/${id}`)
        .then(() => {
          dispatch({
            type: "DELETE_CTA_CREATION_PACKAGE_PUBLICTE_SUCCESS",
          });

          toast.success("Cta supprimé avec succès");

          dispatch({
            type: "DELETE_CTA_LOCALLY",
            payload: id,
          });
        })
        .catch(err => {
          dispatch({ type: "DELETE_CTA_CREATION_PACKAGE_PUBLICTE_FAIL" });
          console.log(err);
        });
    }
  };

  const handleChangeNewTag = e => {
    setNewTag(e.target.value);
  };

  const saveNewTag = (e, cta) => {
    if (e.key === "Enter") {
      if (!newTag) {
        toast.error("Veuillez insérer un tag");
        return;
      }

      const dataToSend = { ...cta, keywords: [...cta.keywords, newTag] };

      axiosInstance
        .post(`/${adaccountId}/call_to_action/${cta.id}`, dataToSend)
        .then(() => {
          dispatch({
            type: "UPDATE_CTA_CREATION_PACKAGE_PUBLICTE_SUCCESS",
          });

          toast.success("Tag ajouté avec succès");

          dispatch({
            type: "ADD_TAG_CTA_LOCALLY",
            payload: { id: cta.id, tag: newTag },
          });
        })
        .catch(err => {
          dispatch({ type: "UPDATE_CTA_CREATION_PACKAGE_PUBLICTE_FAIL" });
          console.log(err);
        });

      setNewTag("");
    }
  };

  const deleteTag = (cta, tag) => {
    if (window.confirm("Voulez-vous vraiment supprimer ce tag ?")) {
      const dataToSend = {
        ...cta,
        keywords: cta.keywords.filter(item => item !== tag),
      };

      axiosInstance
        .post(`/${adaccountId}/call_to_action/${cta.id}`, dataToSend)
        .then(() => {
          dispatch({
            type: "DELETE_TAG_CTA_CREATION_PACKAGE_PUB",
            payload: {
              id: cta.id,
              tag,
            },
          });

          toast.success("Tag supprimé avec succès");
        })
        .catch(err => {
          dispatch({ type: "UPDATE_CTA_CREATION_PACKAGE_PUBLICTE_FAIL" });
          console.log(err);
        });
    }
  };

  const {
    callToActions,
  } = useSelector(state => state.creationCampagneRef);

  const invertedCtas = inverseCleValeur(callToActions);
  const titleToShow = invertedCtas[texte.content];
  // eslint-disable-next-line
  const [searchParams, setSearchParams] = useSearchParams();

  const tagToEdit = searchParams.get("tagToEdit");

  const { nomPackage } = useSelector(state => state.creationPackagePublicite);

  const toggleSelectItem = id => {
    if (tagToEdit && texte.isSelected) {
      if (valeurExiste(texte.keywords, nomPackage)) {
        const dataToSend = {
          ...texte,
          keywords: texte.keywords.filter(item => item !== nomPackage),
        };

        axiosInstance
          .post(`/${adaccountId}/call_to_action/${texte.id}`, dataToSend)
          .then(() => {
            dispatch({
              type: "DELETE_TAG_CTA_CREATION_PACKAGE_PUB",
              payload: {
                id: texte.id,
                tag: nomPackage,
              },
            });
          })
          .catch(err => {
            console.log(err);
          });
      }
    }

    dispatch({ type: "TOGGLE_SELECT_CTA", payload: id });
  };

  return (
    <div
      onClick={() => toggleSelectItem(texte.id)}
      className={`text ${texte.isSelected ? "selected" : ""}`}
    >
      <i
        onClick={e => {
          e.stopPropagation();
          deleteCta(texte.id);
        }}
        className='fas close fa-times'
      ></i>
      <h5 style={{ wordBreak: "break-all" }}>{titleToShow || texte.content}</h5>
      {showTags && texte.keywords && (
        <React.Fragment>
          <div className='tags'>
            {texte.keywords.length > 0 ? (
              texte.keywords.map((tg, i) => (
                <div key={i} className='tag' onClick={e => e.stopPropagation()}>
                  <p>{tg}</p>
                  <i
                    onClick={() => deleteTag(texte, tg)}
                    className='fas fa-times'
                  ></i>
                </div>
              ))
            ) : (
              <h6>Aucun tag pour l'instant</h6>
            )}
          </div>

          <div className='add_tag' onClick={e => e.stopPropagation()}>
            <input
              onKeyDown={e => saveNewTag(e, texte)}
              value={newTag}
              onChange={handleChangeNewTag}
              type='search'
              name=''
              id=''
              placeholder='Tags'
            />
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default CtaItem;
